import { render, staticRenderFns } from "./RatioImage.vue?vue&type=template&id=915eb376&scoped=true&"
import script from "./RatioImage.vue?vue&type=script&lang=js&"
export * from "./RatioImage.vue?vue&type=script&lang=js&"
import style0 from "./RatioImage.vue?vue&type=style&index=0&id=915eb376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915eb376",
  null
  
)

export default component.exports